import { connect } from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';

import config from 'app/config';
import { eljurMakeLink } from 'app/actions/eljur/link';
import { ejUserFetch as ejUserFetchAction } from 'app/actions/eljur/user';
import { saveToken as saveTokenAction } from 'app/common/actions/user/tokens';
import { EXT_ELJUR } from 'app/common/constants/services';
import selectTokenData from './selectTokenData';


const enhance = compose(
  connect(
    (state, props) => ({
      ejLoginUrl: config.ejLoginUrl,
      error: state.eljur.user.error,
      tokenData: selectTokenData(state, props),
      savingToken: state.user.savingToken,
    }),
    dispatch => ({
      ejUserFetch: (token, vendor) => dispatch(ejUserFetchAction(token, vendor)),
      saveToken: async (service, token, vendor) => {
        await dispatch(saveTokenAction(service, token, vendor));
      },
      makeLink: async () => {
        await dispatch(eljurMakeLink());
      },
    })
  ),


  withState('isLogin', 'showLogin', false),


  withHandlers({
    handleShowLogin: ({ showLogin }) => (e) => {
      e.preventDefault();
      showLogin(true);
    },
    handleCloseLogin: ({ showLogin }) => (e) => {
      e.preventDefault();
      showLogin(false);
    },
  }),


  lifecycle({
    componentDidMount() {
      const { token, vendor, isSaved } = this.props.tokenData;

      if (token && vendor) {
        if (!isSaved) {
          this.props.saveToken(EXT_ELJUR, token, vendor);
        }
        this.props.ejUserFetch(token, vendor);
      }
    },
  })
);

export default enhance;
